import * as React from 'react'
import moment from 'moment'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { RepeatableSection } from '../components/RepeatableSection'
import { CurrencyModel } from '@/app/models/newDelegation/currencyModel'
import { DriverQualificationsType } from '@/app/constants/driverQualificationsType'

import { DriverWorkYearsPeriods } from '@/app/constants/configuration/driverWorkYearsPeriods'

import { SwedenDriverWorkYearsPeriods } from '@/app/constants/configuration/swedenDriverWorkYearsPeriods'
import { SwedenMinimumWageExpandableItemModel } from '@/app/models/configuration/minimumWage/swedenMinimumWageConfigurationModel'
import { getSwedenDriverWorkYearsPeriodsWorkName } from '@/app/common/converters/configuration/swedenDriverWorkYearsPeriodsToTextConverter'

type Props = {
  driverWorkYears?: SwedenDriverWorkYearsPeriods[]
  allowedCurrencies?: string[]
  qualificationTypes?: DriverQualificationsType[]
  state: {
    configuration: { currencies: CurrencyModel[] }
    expandableItems: SwedenMinimumWageExpandableItemModel[]
  }
  setState: React.Dispatch<
    React.SetStateAction<{
      expandableItems: SwedenMinimumWageExpandableItemModel[]
    }>
  >
}

const DRIVER_WORK_YEARS_PERIODS_DEFAULT = [
  DriverWorkYearsPeriods.All,
  DriverWorkYearsPeriods.None,
]

const QUALIFICATION_TYPES_DEFAULT = [DriverQualificationsType.NotSet]

export const SwedenMinimumWageExpandableItemSection = ({
  allowedCurrencies,
  driverWorkYears,
  qualificationTypes,
  state,
  setState,
}: Props) => {
  const { t } = useLocalize()

  return (
    <RepeatableSection<SwedenMinimumWageExpandableItemModel>
      title={t('configuration.minimumWages.minimalHourRateTitle')}
      newRow={() => ({
        configurationValueId: 0,
        rateValue: 0,
        dateFrom: moment(),
        driverYears: 0,
        rateCurrency: state.configuration.currencies[0],
        driverQualifications: DriverQualificationsType.Guard,
        isNew: true,
        isEdited: true,
      })}
      columns={[
        {
          order: 1,
          label: t('configuration-minimumWage.from-date'),
          type: 'date',
          get: (r) => r.dateFrom,
          set: (r, v) => ({ ...r, dateFrom: moment(v) }),
        },
        // {
        //     order: 3,
        //     label: "Typ",
        //     type: "select",
        //     hidden: !Array.isArray(qualificationTypes),
        //     options: (qualificationTypes || []).map((value) => ({
        //         value, label: getDriverQualificationTypeName(value, t),
        //     })),
        //     get: (r) => {
        //         console.log("R", r)
        //         return r.driverQualification
        //     },
        //     set: (r, v: DriverQualificationsType) => ({ ...r, driverQualification: v }),
        // },
        {
          order: 4,
          label: t('common.amount'),
          type: 'price',
          get: (r) => r.rateValue,
          set: (r, v: number) => ({ ...r, rateValue: Number(v) }),
        },
        {
          order: 5,
          label: t('configuration.countries.currency'),
          type: 'select', //"currency",
          options: state.configuration.currencies
            .filter((c) =>
              Array.isArray(allowedCurrencies)
                ? allowedCurrencies.includes(c.code)
                : true,
            )
            .map((c) => ({ label: `${c.code} - ${c.name}`, value: c.code }))
            .sort((a, b) => a.label.localeCompare(b.label)),
          get: (r) => r.rateCurrency.code,
          set: (r, v) => {
            const selected = state.configuration.currencies.find(
              (c) => c.code === v,
            )
            return { ...r, rateCurrency: selected }
          },
        },
        {
          order: 6,
          label: t('configuration.minimumWages.driverWorkYears'),
          type: 'select',
          hidden: !Array.isArray(driverWorkYears),
          options: (driverWorkYears || []).map((value) => ({
            value: value.toString(),
            label: getSwedenDriverWorkYearsPeriodsWorkName(value, t),
          })),
          get: (r) => r.driverYears,
          set: (r, v) => {
            return { ...r, driverYears: v as SwedenDriverWorkYearsPeriods }
          },
        },
      ]}
      canAddRow={true}
      rows={state.expandableItems}
      setRows={(next) => {
        setState((prev) => {
          const current = prev.expandableItems
          const nextRows =
            typeof next === 'function'
              ? (next as (p: typeof current) => typeof current)(current)
              : next
          return { ...prev, expandableItems: nextRows }
        })
      }}
      sortRows={(a, b) => {
        const da = moment(a.dateFrom)
        const db = moment(b.dateFrom)
        const ta = da.valueOf()
        const tb = db.valueOf()
        if (ta === tb) return 0
        return ta > tb ? -1 : 1
      }}
    />
  )
}
